import { Component, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { CleverTapConstents, ConstantData } from 'src/app/services/constants';
import { TosterMsgType } from 'src/app/services/model';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-selfie',
  templateUrl: './selfie.component.html',
  styleUrls: ['./selfie.component.scss']
})
export class SelfieComponent {
  get currentApplicant() {
    const loan = this.util.loanDetails; 
    if(!loan){
      return {};
    }
    const app = loan.loanApplicantDetails.find((app:any) => app.id === this.util.getCurrentApplicant.id);
    return { ...app, selfiNotComplete: !app?.mainApplicant || this.isMoratorium || loan.loanApplicantDetails.length === 1 ? true: app.selfiNotComplete};
  }
  get isMoratorium():boolean{
    return this.util.loanDetails && (this.util.loanDetails.hasMoratorium || this.util.loanDetails.isCapacitaFlow) && !(!this.util.loanDetails.isStudentMainApplicant && !this.util.loanDetails.isSponser);
  }
  isCameraPermission:boolean  = true;
  guardianFlowPopup:boolean = false;
  @Input() switchTabs:Subject<any> = new Subject();
  // isSelfieApplicant:boolean = false;
  constructor(public util: UtilService) { }
  ngOnInit(): void {
    this.util.askForCameraPermission();
    this.switchTabs.subscribe((res)=>{
      this.switchTab(res);
     });
    this.util.setCache('proofTab', 'selfie');
    this.init(); 
    this.util.userLoggedInEventCalled.subscribe(()=>{
      this.init();
    });
    

  }

  init(){
    if(!this.util.loanDetails){
      return;
    }
    const applicant = this.util.loanDetails.loanApplicantDetails.find((app:any) => app.selfiNotComplete);
    applicant && this.util.setCache('currentApplicant', applicant?.id);
    this.loadSelfie();
  }

  openCamDialog: boolean = false;
  webcamImage: any = 'assets/images/selfie_image.jpg';
  dWebcamImage: any = 'assets/images/selfie_image.jpg';
  fileFormData: any;
  beforeLoadUserPhotos: boolean = false;

  loadSelfie(){
    if(!this.currentApplicant?.selfiNotComplete){
      const file = this.currentApplicant?.loanAttachment?.find((element:any) => element.docType == 'SELFIE');
      
      this.util.handleRequests('blobFile', this.util.getUrl('attachment_download', [file?.attachmentId])).then((res:any)=>{
        if(res.blobFile){
          this.webcamImage = res.blobFile;
          this.beforeLoadUserPhotos = true;
          
        }
        
      });
    }
  }
  verifySelfie() {
    this.util.showWaitingScreen(ConstantData.waitingScreenStatus.selfieUploading);
    const formData = new FormData();
    formData.append('file', this.fileFormData);
    this.util.handleRequests('put', this.util.getUrl('attachment_selfie'), formData, undefined, undefined, undefined, false).then((res: any) => {
      const fileId = res.fileId;
      if (res['status'] === 'ERROR') {
        this.onError({ msg: res['content']['message'] });
    this.util.cleverTapEventCall(CleverTapConstents.selfie_verification_failed,{
      'applicantType': this.util.getCurrentApplicant.mainApplicant == true ?"Main Applicant":"Co-Applicant",
      'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
    });
      } else if (fileId) {
          this.util.handleRequests('put', this.util.getUrl('loan_update_selfie', [this.util.getCurrentApplicant.id]), { 'loanId': this.util.loanDetails.loanId, 'attachmentId': fileId }, undefined, undefined, undefined, false).then(() => {
            this.util.getProducts(undefined, false).then(() => {
              this.util.cleverTapEventCall(CleverTapConstents.selfie_verified,{
                'applicantType': this.util.getCurrentApplicant.mainApplicant == true ?"Main Applicant":"Co-Applicant",
                'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
              });
              if(this.isMoratorium && this.util.getCurrentApplicant.mainApplicant){
                this.util.hideWaitingScreen(false);

                this.addCoApplicant()
              }
              else if(this.util.loanDetails.loanApplicantDetails.some((app:any) => app.selfiNotComplete)){
                this.webcamImage = this.dWebcamImage;
                this.beforeLoadUserPhotos = false;
                this.util.hideWaitingScreen(false);
              
              this.switchTab(false);
              this.util.navigationHandler();
              }
            })
          }).catch((err: any) => {
            this.onError(err);

          });
        }

    }).catch((err: any) => {
      this.onError(err);

    });
  }
  openToCamViewDialog() {
    this.util.cleverTapEventCall(CleverTapConstents.selfie_verification_initiated,{
      'applicantType': this.util.getCurrentApplicant.mainApplicant == true ?"Main Applicant":"Co-Applicant",
      'loanId': this.util.loanDetails.loanId, 'productCode': this.util.loanDetails.productCategory,
    });
    this.util.askForCameraPermission();
    this.openCamDialog = true;
   
  }

  onError(err: any) {
    this.util.hideWaitingScreen();
    this.util.getProducts().then(() => {
      this.util.navigationHandler();
      this.util.showToaster(err.msg, TosterMsgType.ERROR);
    })
  }

  handleImage(webcamData: any) {
    this.fileFormData = this.changeToImageFormat(webcamData.camData._imageAsDataUrl, `${this.util.getCurrentApplicant.id}.png`);
    this.webcamImage = webcamData.camData.imageAsDataUrl;
    this.openCamDialog = webcamData.popup;
    this.beforeLoadUserPhotos = true;
  }

  changeToImageFormat(dataurl: any, filename: string) {
    let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    } return new File([u8arr], filename, { type: mime });
  }

  switchTab(isMainApplicant: boolean) {
   
    if (isMainApplicant) {
      this.loadSelfie();
     this.webcamImage = this.dWebcamImage;
     this.beforeLoadUserPhotos = false;
    }
  }
  addCoApplicant() {
    this.util.handleRequests('put', this.util.getUrl('loan_addCoapplicant', [this.util.loanDetails.loanId,1])).then((res: any) => {
      this.util.getProducts().then(() => {
        this.guardianFlowPopup = true; 
        setTimeout(() => {
          this.util.navigationHandler();
        }, ConstantData.popUpTimer * 1000);
        
      })

    })
  }
}
